module.exports = "/static/assets/e02b47da60ad2adf5b94b2633fe859c3.png";